import { Form } from "components/Forms";
import { RichText } from "components/RichTextWidget";
import { buildWidgetInstanceId } from "features/widgets";
import { WIDGETS_REGISTRY } from "features/widgets/widgets.config";
import { useRouter } from "next/router";
import {
  AccordionList,
  Action,
  Container,
  Heading3,
  Icon,
  ModalWrapper,
  Paragraph,
} from "shared/components";
import { useToggle } from "shared/hooks";

import styles from "./Content023.module.scss";

export const Content023 = ({ payload }) => {
  const title = payload?.title ?? "";
  const description = payload?.description ?? "";
  const points = payload?.points ?? [];
  const { buttonText, form, type, link } = payload?.requestButton ?? {};

  const instanceId = buildWidgetInstanceId(
    "023",
    payload.id,
    WIDGETS_REGISTRY.CONTENT
  );

  const { query } = useRouter();
  const { opened, onOpen, onClose } = useToggle();

  const baseUrl = typeof window !== "undefined" ? window.location.origin : "";
  const externalLink =
    link?.startsWith("http") || link?.startsWith("https")
      ? link
      : `${baseUrl}${link}`;

  return (
    <div className={styles.wrapper}>
      <Container className={styles.inner}>
        <div className={styles.blocks}>
          <div className={styles.left}>
            <Heading3 as="h3" className={styles.title}>
              {title}
            </Heading3>
            <RichText
              value={description}
              className={styles.description}
              color="dark"
            />
            {type === "external link" ? (
              <a
                href={externalLink}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.button}
              >
                <span className={styles.play}>
                  <Icon className={styles.icon} name="arrow_right" />
                </span>
                <Paragraph color="brand" className={styles["button-text"]}>
                  {buttonText}
                </Paragraph>
              </a>
            ) : (
              <Action onClick={onOpen} className={styles.button}>
                <span className={styles.play}>
                  <Icon className={styles.icon} name="arrow_right" />
                </span>
                <Paragraph color="brand" className={styles["button-text"]}>
                  {buttonText}
                </Paragraph>
              </Action>
            )}
            {opened && (
              <ModalWrapper onCloseModal={onClose}>
                <Form
                  item={form}
                  metaData={{ page: query.slug }}
                  instanceId={instanceId}
                  onReset={onClose}
                />
              </ModalWrapper>
            )}
          </div>
          <div className={styles.right}>
            <AccordionList
              items={points}
              className={styles.list}
              appearance="bold"
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content023;
